import {
    SIGN_UP_STEP_SUBMIT_REQUESTED,
    SIGN_UP_STEP_SUBMIT_ACCEPTED,
    SIGN_UP_STEP_SUBMIT_REJECTED,
    SIGN_UP_STEP_SET,
    SIGN_UP_SUBMITTED,
    SIGN_UP_ACCEPTED,
    SIGN_UP_CONFIRMATION_ISSUED,
    getSignUpData,
} from '@domain/auth/sign-up/sign-up-state';
import { createMiddleware } from '@shared/redux';
import { createHmac } from 'crypto';
import { analytics } from '../analytics';
import { trackOnRudderStack } from '../analytics.utils';

export const signUpMiddleware = createMiddleware({
    [SIGN_UP_STEP_SET]: async (_, { payload }) => {
        const {
            step,
        } = payload;

        await trackOnRudderStack('sign_up_step_set', {
            step,
        });
    },
    [SIGN_UP_STEP_SUBMIT_REQUESTED]: async (_, { payload }) => {
        const {
            data,
            step,
        } = payload;

        const cleanedData = Object.assign({}, data);
        delete cleanedData.password;

        await trackOnRudderStack('sign_up_step_submit_requested', {
            step,
            ...cleanedData,
        });
    },
    [SIGN_UP_STEP_SUBMIT_ACCEPTED]: async (_, { payload }) => {
        const {
            data,
            step,
        } = payload;

        const cleanedData = Object.assign({}, data);
        delete cleanedData.password;

        if (step === 1) {
            await analytics.identify(cleanedData.username, {
                email: cleanedData.username,
            });
        }

        await trackOnRudderStack('sign_up_step_accepted', {
            step,
            ...cleanedData,
        });
    },
    [SIGN_UP_STEP_SUBMIT_REJECTED]: async (_, { payload }) => {
        const {
            step,
            error,
        } = payload;

        await trackOnRudderStack('sign_up_step_rejected', {
            step,
            error,
        });
    },
    [SIGN_UP_SUBMITTED]: async () => {
        await trackOnRudderStack('sign_up_submitted');
    },
    [SIGN_UP_ACCEPTED]: async (state) => {
        const data = getSignUpData(state);
        const emailHash = createHmac('sha256', data.username).digest('hex');
        await trackOnRudderStack('sign_up_accepted');
        localStorage.setItem('NEW_USER_EMAIL', emailHash);
    },
    [SIGN_UP_CONFIRMATION_ISSUED]: async () => {
        await trackOnRudderStack('sign_up_confirmation_issued');
    },
}, { beforeChanges: true });
